import classnames from 'classnames';
import React from 'react';

import { InfoMessage } from '@eika/attention-message';
import { Select } from '@eika/select';

import { ChargeBearerOptions } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import { CrossBorderPaymentActionType } from './form/actions';
import useFormContext from './form/useFormContext';

import './ChargeBearerSelect.scss';

const ChargeBearerSelect: React.FC = () => {
    const translated = useTranslation();
    const { state, handleChange } = useFormContext();
    const showInfoMessage = state.chargeBearer === 'SENDER';

    return (
        <>
            <Select
                label={translated.chargeBearerField.title}
                sublabel={translated.chargeBearerField.description}
                className={classnames('charge-bearer-select', { 'show-info': showInfoMessage })}
                defaultValue={state.chargeBearer}
                onChange={(value) => {
                    handleChange({
                        type: CrossBorderPaymentActionType.SET_CHARGE_BEARER,
                        payload: value.target.value as ChargeBearerOptions,
                    });
                }}
            >
                {state.country?.chargeBearers?.map((options) => {
                    return (
                        <option value={options} key={options}>
                            {translated.chargeBearerSelectOptions[options]}
                        </option>
                    );
                })}
            </Select>
            {showInfoMessage && (
                <InfoMessage
                    className="charge-bearer-select__info-message"
                    text={translated.chargeBearerField.infoMessage}
                />
            )}
        </>
    );
};

export default ChargeBearerSelect;
